// extracted by mini-css-extract-plugin
export default {"wrapper":"devotions_wrapper__r0F-n","image":"devotions_image__AYkoK","inside":"devotions_inside__bM-r5"};